// dB <-> linear gain, Photon's stem slider range (processing.hpp kStemMinDb /
// kStemMaxDb: -48 .. +12 dB, 0 dB = unity) and the readout formats of the
// dB and percent value boxes (ModelSettingsViews.cpp updateValueLabel).

export const DB_MIN = -48;
export const DB_MAX = 12;
export const DB_STEP = 0.1;
export const DB_DEFAULT = 0;

export const dbToLinear = (db: number): number => 10 ** (db / 20);
export const linearToDb = (gain: number): number => 20 * Math.log10(Math.max(gain, 1e-9));
export const clampDb = (db: number): number => Math.min(DB_MAX, Math.max(DB_MIN, db));

// "+6.0 dB", "0.0 dB", "-12.3 dB" — one decimal, explicit plus sign.
export function formatDb(db: number): string {
  const rounded = Math.round(db * 10) / 10;
  const prefix = rounded > 0 ? '+' : '';
  // toFixed keeps "-0.0" for tiny negatives; normalise to "0.0".
  const text = rounded === 0 ? '0.0' : rounded.toFixed(1);
  return `${prefix}${text} dB`;
}

// Accepts what a user types in the dB box ("-6", "+3.5 dB", "2dB"); null when
// it is not a number. The result is clamped to the slider range.
export function parseDb(text: string): number | null {
  const cleaned = text.trim().replace(/db$/i, '').trim();
  if (cleaned === '' || !/^[+-]?\d*\.?\d+$/.test(cleaned)) return null;
  return clampDb(Number(cleaned));
}

// Percent boxes show an integer 0..100 for a stored 0..1 value.
export const strengthToPercent = (strength: number): number => Math.round(strength * 100);
export const percentToStrength = (percent: number): number =>
  Math.min(1, Math.max(0, percent / 100));

export function parsePercent(text: string): number | null {
  const cleaned = text.trim().replace(/%$/, '').trim();
  if (cleaned === '' || !/^\d*\.?\d+$/.test(cleaned)) return null;
  return percentToStrength(Number(cleaned));
}
